<template >
    <div class="container pos-r">
        <Header :title="pageTitle"/>
        <img class="page-bg" :src="Images.img_page_bg2" alt="">
        <div class="header">
            <div class="top">
                <div class="left">
                    <span>累计收益：</span>
                    <p>￥<span>{{dataSources.cumulative}}</span></p>
                </div>
                <div class="btn" @click="_onPressToNavigate('', 'withdrawal', {account_type, user_type})">提现</div>
            </div>
            <div class="bottom">
                <div>
                    <p>￥{{dataSources.withdrawal}}</p>
                    <span>可提现</span>
                </div>
                <p></p>
                <div>
                    <p>￥{{dataSources.frozen}}</p>
                    <span>未结算</span>
                </div>
            </div>
        </div>
        <div class="detail pos-r">
            <div class="left">
                <div>
                    <img :src="Images.icon_wallet_yellow" alt="">
                    <p>收益明细</p>
                </div>
                <p>合计：{{dataSources.total}}元</p>
            </div>
            <div class="right" @click="isShowDatePicker = true">
                <p>{{_formatterCurDate}}</p>
                <img :src="Images.icon_screen" alt="">
            </div>
        </div>
        <div
            class="scrollerView"
            :style="{ height: (wrapperHeight- 320) + 'px' }"
        >
            <scroller
                :on-refresh="_onRefresh"
                :on-infinite="_onEndReached"
                :noDataText="listData.length > 1 ? Constants.ALL_LOAD_TIPS : ''"
                ref="infinite"
                class="scroller"
            >
                <incomeItem v-for="(item, index) in listData" :key="index" :item="item"/>
                <van-empty description="暂无信息～" v-if="listData.length < 1 && !loading" />
            </scroller>
        </div>

        <van-popup v-model="isShowDatePicker" position="bottom">
            <van-datetime-picker
                type="year-month"
                title="选择查询月份"
                v-model="currentDate"
                @confirm="_onConfirmPickerDate"
                @cancel="isShowDatePicker = false"
            />
        </van-popup>
    </div>
</template>

<script>
import moment, { locales } from 'moment';
import Header from '@/components/Header'
import incomeItem from '@/components/item/incomeItem'
export default {
    components: {
        'Header': Header,
        'incomeItem': incomeItem,
    },
    computed: {
        _formatterCurDate() {
            return moment(this.currentDate).format('YYYY-MM');
        }
    },
    data() {
        return {
            pageTitle: this.$route.query.pageTitle || '课程收入',
            loading: false,
            isShowDatePicker: false,
            wrapperHeight: 0, //屏幕高度 - 脚部
            keyword: '',
            page: 0,
            limit: 10,
            dataSources: {},
            listData: [],
            no_more: false,
            no_data: false,
            currentDate: new Date(),
            user_type: this.$route.query.user_type || '',
            account_type: this.$route.query.account_type || '',
        };
    },
    mounted() {
        this.wrapperHeight = document.documentElement.clientHeight;
        this._requestDataSources();
    },
    methods: {
        onBack() {
            this.$router.back();
        },

        // 点击跳转
        _onPressToNavigate(pageTitle, path, query) {
            if (pageTitle) {
                query = {
                    ...query,
                    pageTitle,
                }
            }
            this.$router.push({
                path,
                query
            });
        },

        _onPressToWeb(url) {
            if(!url) return;
            console.log('url---->', url);
            window.location.href = url;
        },

        _onConfirmPickerDate(value) {
            console.log('value---->', value);
            this.currentDate = value;
            this.isShowDatePicker = false;
            !this.loading && this._onRefresh();
        },

        async _requestDataSources() {
            let url = this.API.revenue_list;
            let data = {
                page: this.page,
                limit: this.limit,
                type: this.user_type,
                account_type: this.account_type,
                create_time: moment(this.currentDate).format('YYYY-MM'),
            };
            try {
                this.loading = true;
                const result = await this.$post(url, data);
                let dataSourcesTemp = this.listData.slice();
                let dataList = [];
                if (result.code === this.GLOBAL.SUCCESS_CODE) {
                    this.dataSources = result.data;
                    dataList = result.data.data || [];
                    if (parseInt(data.page) === 1) {
                        dataSourcesTemp = dataList
                    } else {
                        if (dataList.length !== 0) {
                            dataSourcesTemp = dataSourcesTemp.concat(dataList);
                        }
                    }
                }
                this.listData = dataSourcesTemp;
                this._onStopLoading(dataList.length < this.limit);
            } catch (error) {
                console.log('error---->', error);
                this._onStopLoading(true);
            }
        },

        // 下拉刷新
        _onRefresh() {
            this.page = 1;
            this._requestDataSources();
        },

        // 上拉加载
        _onEndReached() {
            if (this.loading) return;
            this.page++;
            this._requestDataSources();
        },

        // 结束加载
        _onStopLoading(status = true) {
            console.log('status---->', status, this.dataSources);
            setTimeout(() => {
                this.loading = false;
                this.$refs && this.$refs.infinite.finishPullToRefresh();
                this.$refs && this.$refs.infinite.finishInfinite(status);
            }, 500);
        },
    },
};
</script>

<style lang="less" scoped>
.page-bg {
    top: 0;
    z-index: 0;
    width: 100%;
    position: absolute;
}

.scrollerView {
    position: relative;
    width: calc(100% - 30px);
    margin: 10px 15px 0;
    box-sizing: border-box;
}

.scroller {
    background: #fff;
    box-sizing: border-box;
}

.header {
    position: relative;
    z-index: 1;
    height: 150px;
    padding: 10px;
    margin: 15px 15px 0;
    box-sizing: border-box;
    background: #fff;
    border-radius: 10px;
    box-shadow: 0px 4px 13px 0px rgba(10,24,99,0.06);
    display: flex;
    flex-direction: column; 
    justify-content: space-between;

    .top {
        display: flex;
        align-items: center;

        .left {
            flex: 1;

            > span {
                font-size: 13px;
                color: #6472E8;
            }

            > p {
                margin-top: 10px;
                font-size: 16px;
                color: #FF9C00;

                > span {
                    font-size: 22px;
                }
            }
        }

        .btn {
            margin-top: 10px;
            width: 98px;
            height: 35px;
            background: linear-gradient(225deg,#9cb2f4, #6472e8);
            border-radius: 18px;
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 18px;
            color: #fff;
        }
    }

    .bottom {
        display: flex;
        align-items: center;

        > p {
            width: 1px;
            height: 21px;
            background: #E1E1E1;
        }

        > div {
            flex: 1;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;

            p {
                margin-bottom: 5px;
                font-size: 16px;
                color: #666;
            }

            span {
                font-size: 14px;
                color: #666;
            }
        }
    }
}

.detail {
    height: 64px;
    margin: 10px 15px 0;
    padding: 10px;
    box-sizing: border-box;
    background: #ffffff;
    border-radius: 3px;
    box-shadow: 0px 4px 13px 0px rgba(10,24,99,0.06);
    display: flex; 
    align-items: center;

    .left {
        flex: 1;
        display: flex;
        flex-direction: column;
        justify-content: space-between;

        > div {
            display: flex;
            align-items: center;

            > img {
                width: 15px;
                height: 15px;
                margin-right: 5px;
            }

            > p {
                font-size: 15px;
                color: #333;
            }
        }

        > p {
            font-size: 13px;
            color: #7181EB;
        }
    }

    .right {
        width: 130px;
        height: 30px;
        padding: 0 10px;
        box-sizing: border-box;
        background: #f8f8f8;
        display: flex;
        align-items: center;


        p {
            flex: 1;
            font-size: 13px;
            color: #7181EB;
        }

        img {
            width: 10px;
            height: 15px;
        }
    }
}
</style>